class CondenseContent extends HTMLElement {
  constructor() {
    super()
    this.toogleButton = this.querySelector('.content-toggle')
    this.truncateContent = this.querySelector('.condensed-content')
    this.truncateContentMobile = this.querySelector('.condensed-content-mobile')
    this.completeContent = this.querySelector('.complete-content')
    this.showMoreText = this.dataset.showMoreText
    this.showLessText = this.dataset.showLessText
  }

  connectedCallback() {
    this.toogleButton.addEventListener('click', ()=> {
      if(this.classList.contains('collapsed')) {
        this.truncateContent.classList.add('hidden')
          if (this.truncateContentMobile){
            this.truncateContentMobile.classList.add('hidden')
          }
          if(  this.completeContent){
             this.completeContent.classList.remove('hidden')
          }
          
       
        this.toogleButton.textContent = this.showLessText
      } else {
        this.truncateContent.classList.remove('hidden')
         if (this.truncateContentMobile){
            this.truncateContentMobile.classList.remove('hidden')
         }
         if(  this.completeContent){
           this.completeContent.classList.add('hidden')
         }
        
        this.toogleButton.textContent = this.showMoreText
      }

      this.classList.toggle('collapsed')
    })
  }
}

customElements.define('condensed-content', CondenseContent)